import clsx from 'clsx';
import { CircleAlert, CircleCheck, Info, TriangleAlert } from 'lucide-react';
import type { ReactNode } from 'react';

type Tipo = 'erro' | 'aviso' | 'ok' | 'info';

const estilos: Record<Tipo, { caixa: string; Icone: typeof Info }> = {
  erro: { caixa: 'border-erro/30 bg-erro-fundo text-erro', Icone: CircleAlert },
  aviso: { caixa: 'border-aviso-borda/60 bg-aviso-fundo text-aviso', Icone: TriangleAlert },
  ok: { caixa: 'border-ok/30 bg-ok-fundo text-ok', Icone: CircleCheck },
  info: { caixa: 'border-linha bg-superficie text-tinta-2', Icone: Info },
};

export function Aviso({ tipo, titulo, children, className }: { tipo: Tipo; titulo?: string; children?: ReactNode; className?: string }) {
  const { caixa, Icone } = estilos[tipo];
  return (
    <div role={tipo === 'erro' ? 'alert' : 'status'} className={clsx('flex gap-2.5 rounded-painel border px-3.5 py-3', caixa, className)}>
      <Icone aria-hidden className="mt-0.5 size-4 shrink-0" />
      <div className="min-w-0">
        {titulo && <p className="font-semibold">{titulo}</p>}
        {children && <div className={clsx(titulo && 'mt-0.5', 'text-tinta')}>{children}</div>}
      </div>
    </div>
  );
}
